<template>
  <application :user="user" :header-attrs="headerAttrs">
  </application>
</template>

<script lang="ts">
  import Vue from "vue";
  import User from "../../common/models/user";
  import IBreadcrumb from "../../common/interfaces/breadcrumbInterfaces";
  import {Hash} from "../../common/interfaces/hashInterfaces";

  export default Vue.extend({
    props: {
      user: {
        type: Object as () => User,
        required: true,
      },
      html: {
        type: String,
      },
      breadcrumbs: {
        type: Array as () => IBreadcrumb[],
        default: () => {
          return [];
        },
      }
    },
    data: function () {
      return {};
    },
    computed: {
      headerAttrs(): Hash {
        return {
          showCustomLogo: true,
          breadcrumbs: this.breadcrumbs,
        };
      },
    }
  });
</script>